import React from "react";
import Reveal from "./Reveal";
import { Whatsapp, Linkedin, Sparkles } from "./Icons";

/* Seção de CTA / contato reutilizada na Home e nas páginas de projeto. */
function Contato({
  titulo = "Vamos construir algo juntos?",
  texto = "Estou aberto a novos projetos e oportunidades. Me chame para conversarmos sobre como posso ajudar a tirar a sua ideia do papel.",
}) {
  return (
    <section className="section" id="contato">
      <div className="container">
        <Reveal className="cta">
          <div className="cta-inner">
            <span className="eyebrow">
              <Sparkles width={14} height={14} /> Contato
            </span>
            <h2>{titulo}</h2>
            <p>{texto}</p>
            <div className="cta-actions">
              <a
                className="btn btn-primary"
                href="https://api.whatsapp.com/send/?phone=5547999284866"
                target="_blank"
                rel="noreferrer"
              >
                <Whatsapp width={18} height={18} /> Chamar no WhatsApp
              </a>
              <a
                className="btn btn-ghost"
                href="https://www.linkedin.com/in/bruno-rodrigues-609146181/"
                target="_blank"
                rel="noreferrer"
              >
                <Linkedin width={18} height={18} /> LinkedIn
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default Contato;
